<script>
import Blob from '../../Utils/Blob'

export default {
  name: "Meditator",
  components: { Blob },
  props: [ 'meditator' ],
  computed: {
    id() { return this.meditator.id },
    colors() { return this.meditator.colors },
  },
}
</script>

<template>
  <div
    class="meditator"
  >
    <Blob
      :id="id"
      :colors="colors"
    />
  </div>
</template>

<style scoped>
.meditator {
  position   : relative;
  box-sizing : border-box;
  height     : 15vh;
  width      : 15vh;
  transition : all 0.5s ease;
  background : radial-gradient(var(--dark1), transparent);
  overflow   : visible;
}

.meditator.current {
  position: absolute;
  bottom: 4vh;
  right: calc( 50vw - 7.5vh );
  transform: scale(1.2);
}

.isMobile .meditator {
  height     : 20vw;
  width      : 20vw;
}
.isMobile .meditator.current {
  position: absolute;
  bottom: 15vh;
  right: calc( 50vw - 10vw );
  transform: scale(1.2);
}

</style>
